<template>
	<div class="ReMediaCharts mb-5">
		<!-- <div class="d-flex">
			<h4 class="mr-2">Медиа-чарты</h4>
		</div> -->

		<div class="col-sm-12 col-md-10 priceChart px-0">
		<span v-if="TheData ==''" class="text-center">Нет данных статистики</span>
		<div class="card-chart" v-if="TheData !=''">
			<!-- <template slot="header">
				<h4>Динамика цены</h4>
				<h4 class="card-title" :class="[{'text-success':bLastPrice},{'text-danger':!bLastPrice}]"><i class="tim-ic mr-2" :class="[{'ic-arrow-top':bLastPrice},{'ic-arrow-bottom':!bLastPrice},{'text-success':bLastPrice},{'text-danger':!bLastPrice}]"></i>на {{idynAmRub}}</h4>
			</template> -->
			<h4 >Статистика</h4>
			
			<div class="chart-area" >
				<bar-chart
				:labels="OlapChart.chartData.labels"
				:chart-data="OlapChart.chartData"
				:chart-options="OlapChart.chartOptions"
				:extra-options="OlapChart.extraOptions"
				:plugins="OlapChart.plugins"
				:height="150"
				
				>
				</bar-chart>
				
				<!-- <line-chart
				:labels="OlapChart.chartData.labels"
				:chart-data="OlapChart.chartData"
				:extra-options="OlapChart.extraOptions"
				:height="200"
				>
				</line-chart> -->
				<!-- <base-button type="primary" simple @click="setChartData()" >GET срань господня</base-button> -->

			</div>
		</div>

		</div>


	</div>
</template>

<script>
	import BarChart from 'src/components/Charts/BarChart';
	import moment from 'moment';
	import config from '@/config';
	import { DatePicker, Select, Option, Table, TableColumn, Tooltip, Button, Checkbox } from 'element-ui';
	import Plural from 'src/mixins/Plural.js';
	// import { BaseRadio } from 'src/components/index';
	// import Pagination from 'src/our_components/RePagination';
	// import ReActionBtns from 'src/our_components/ReActionBtns.vue';
	// import { BaseSwitch } from 'src/components/index';
	// import { TabPane, Tabs } from 'src/components';

/*
я тут до конца осознал про v-model и props value внутри компонента:
радовался тому что в value можно писать и всё работает - нихрена. 
1) Если value сложный тип (например массив или объект) - тогда можно элементы массива/объекта и ничего за это не будет, т.к. ЖС говно
2) Если тип простой string или number - то хер чё поменяешь в value, только this.$emit('input', 'ЗНАЧЕНИЕ');
3) Если напрямую переписывать сложные тип, например value = {key:'value'} - то хер, будет ошибка
а ещё во всех слуаях он выдаст ошибку, но значение в value запишет
*/
/* Сломалась реактивность на объекте или массиве: 
	Этот чудесный кослыль родился потому что VUE не может нормально следить за массивами и теряется реактивность
	https://v2.vuejs.org/v2/guide/reactivity.html#Change-Detection-Caveats

Для объекта:
	this.$set(this.objChosenTP,this.ApiData[i].siteId, {'choise':'','cost':0, 'phone':{"contact_id":"","contact_type":"1","contact_value":"","contact_view":"","contact_group":"phone"}});
Для Массива:
	Vue.set(this.masCheckListParams,obj_index, [{val_id:obj_index, elements: masElements}]);
*/
	export default {
		name: 'ReMediaCharts',
		mixins: [Plural],
		components: {
			BarChart,
			[Select.name]: Select,
			[Option.name]: Option,
			[DatePicker.name]: DatePicker,
			[Table.name]: Table,
			[TableColumn.name]: TableColumn,
			[Tooltip.name]: Tooltip,
			[Button.name]: Button,
			[Checkbox.name]: Checkbox,
			// Pagination,
			// BaseRadio,
			// ReActionBtns,
			// BaseSwitch,
			// TabPane, 
			// Tabs,
		},
		props: {
			counter: String,
			findId: { //это свойсво удалять не надо, оно хорошее и моет быть использовано в опуиях для формпринтера или фильтрпринтера
				type: String,
				default: '',
			},
			TheData: [Object, String, Array] // ибо задолбало, что в разных площадках могут придти все эти типы
			
		},
		data () {
			return {
				ver: 1,
				
				minDate: moment().subtract(6,'month'),
				maxDate: moment(),
			}
			
		},
		watch:{
			
		},
		computed: {
			OlapChart() {
				let OlapChart = {
					chartData: {
						labels: [
						
						],
						datasets: [
							{
								label: 'Просмотры',
								fill: true,
								borderWidth: 0,
								data: [],
								hoverBorderWidth: 6,
								// backgroundColor: this.getRandomColor(),
								// backgroundColor:  config.gradientColors,

								backgroundColor: config.colors.primary,
								hoverBackgroundColor: config.colors.primary,
								borderColor: config.colors.primary,
							},
							{
								label: 'Добавлено в избранное',
								fill: true,
								borderWidth: 0,
								// borderDash: [],
								// borderDashOffset: 0.0,
								data: [],
								hoverBorderWidth: 6,
								// backgroundColor: this.getRandomColor(),
								backgroundColor: config.colors.info,
								hoverBackgroundColor: config.colors.info,
								borderColor: config.colors.info,
							},
							{
								label: 'Просмотр контакта',
								fill: true,
								borderWidth: 0,
								// borderDash: [],
								// borderDashOffset: 0.0,
								data: [],
								hoverBorderWidth: 6,
								backgroundColor: config.colors.warning,
								hoverBackgroundColor: config.colors.warning,
								borderColor: config.colors.warning,
								// backgroundColor: this.getRandomColor(),
							},
						]
					},
					// extraOptions: chartConfigs.barChartOptionsGradient,

					extraOptions:{
						// xaxis: { type: "time", timeformat: "%d.%m.%y" }, // похоже не работает, хотя за основу взят chart.js
						maintainAspectRatio: true,
						responsive: true,
						interaction: {
							intersect: false,
						},
						legend: {
							display: true,
							align: 'start',
							position: 'bottom',
							labels: {
								fontColor: '#9499a7',
								fontSize: 16,
								borderRadius: '6px', //кажется не работает Border radius of the legend box
							},
						},
						scales: {
							xAxes: [{
								gridLines: {
									drawBorder: true,
									color: 'rgba(253,93,147,0.2)',
									zeroLineColor: 'rgba(0,191,154,0.4)' //'transparent'
								},
								ticks: {
									padding: 5,
									fontSize: 13, //кажется это не вполне адаптивно, надо проверить, когда будет 30 дней данных. если убрать параметр, то оно само работает
									fontColor: '#9499a7'
								}
							}],
							yAxes: [{
								gridLines: {
									drawBorder: false,
									color: 'rgba(253,93,147,0.2)',
									zeroLineColor: 'rgba(0,191,154,0.4)' //'transparent'
								},
								ticks: {
									padding: 10,
									fontSize: 13,
									fontColor: '#9499a7'
								},
								beginAtZero: true
							}]
						}
					},
				};
				OlapChart.chartData.labels = [];
				OlapChart.chartData.datasets[0].data = [];
				OlapChart.chartData.datasets[1].data = [];
				OlapChart.chartData.datasets[2].data = [];
				Object.keys(this.TheData).forEach((key)=>{
					// console.log(moment(this.TheData[key].date));
					let date = moment(this.TheData[key].date);
					if(date.isBetween(this.minDate, this.maxDate)){
						let strDate = date.format("DD.MM.YY");
						if(strDate == "Invalid date") strDate = '';
						OlapChart.chartData.labels.push(strDate);
						OlapChart.chartData.datasets[0].data.push(this.TheData[key].views);	
						OlapChart.chartData.datasets[1].data.push(this.TheData[key].favorites);	
						OlapChart.chartData.datasets[2].data.push(this.TheData[key].phones);	
					}
				});
				return OlapChart;
			}
			/*
			strSetChartData: function(){
				this.OlapChart.chartData.labels = [];
				this.OlapChart.chartData.datasets[0].data = [];
				this.OlapChart.chartData.datasets[1].data = [];
				this.OlapChart.chartData.datasets[2].data = [];
				Object.keys(this.TheData).forEach((key)=>{
					let strDate = moment(this.TheData[key].date).format("DD.MM.YY");
					if(strDate == "Invalid date") strDate = '';
					this.OlapChart.chartData.labels.push(strDate);
					this.OlapChart.chartData.datasets[0].data.push(this.TheData[key].views);	
					this.OlapChart.chartData.datasets[1].data.push(this.TheData[key].favorites);	
					this.OlapChart.chartData.datasets[2].data.push(this.TheData[key].phones);	
									
				});

				return '';
			},
			*/
		},
		methods: {
			strSetChartData(){
				return ;
			},
			setChartData(){
				// пока эту ф-ю не использую, потому что считаю в компьютед
				this.OlapChart.chartData.labels = [];
				this.OlapChart.chartData.datasets[0].data = [];
				
				
				Object.keys(this.TheData).forEach((key)=>{
					let strDate = moment(this.TheData[key].date).format("DD.MM.YY");
					if(strDate == "Invalid date") strDate = '';
					this.OlapChart.chartData.labels.push(strDate);
					this.OlapChart.chartData.datasets[0].data.push(this.TheData[key].views);
					// console.log('this.TheData', key);
				});
				
			},
			// getRandomColor() {
			// 	let colorArr = [];
			// 	for (let i = 0; i < 50; i++) {
			// 		let letters = '0123456789ABCDEF'.split('');
			// 		let color = '#';
			// 		for (let j = 0; j < 6; j++ ) {
			// 			color += letters[Math.floor(Math.random() * 16)];
			// 		}
			// 		colorArr.push(color);
			// 		// console.log(color);
			// 	}
			// 	return colorArr;
			// }
			
		},
		mounted() {
			// console.log('config.barChartOptionsGradient',config.barChartOptionsGradient);
			
		}
	}
</script>
<style scoped>

/* .ReMediaCharts {border: 1px solid #01b0e0; padding: 20px; border-radius: 6px;} */
.ReMediaCharts-warning {border: 1px dashed #F84E54; padding: 20px 5px 0px 15px; border-radius: 6px; }
.ReMediaCharts-warning, .warning-msg {display: flex; flex-direction: column; align-items: center;}
.ReMediaCharts .badge {line-height: inherit;}
.ReMediaCharts-form {display: flex; flex-direction: row; align-items: flex-start;}
.auction, .ReMediaCharts-plan {    
	margin: 15px 0px;
    border-radius: 6px;
    padding: 10px;
}
.auction {border: 1px dashed #BA54F5;}
.ReMediaCharts-plan {border: 1px dashed #01B0E0; }
.ReMediaCharts-form .btn-position {margin-top: 32px;}

.ReMarketingSitesOnObj {border: 1px dashed #01b0e0; padding: 20px 5px 0px 15px; border-radius: 6px;}
.notEnoughMoney {display: flex; flex-direction: column;}
.notEnoughMoney p, .notEnoughMoney a {text-align: center;}
/* .ReMediaCharts >>> .notEnoughMoney p {color: #1d253b!important;} */
.ReMediaCharts >>> .bootstrap-switch{width: 70px !important; margin: 0;}
.ReMediaCharts >>> .bootstrap-switch .bootstrap-switch-label{left: 55%;}
.ReMediaCharts >>> .bootstrap-switch-container{width: 106px !important;}
.ReMediaCharts >>> .bootstrap-switch .bootstrap-switch-handle-off {text-indent: 6px; padding-right: 6px!important;}
.ReMediaCharts >>> .nav-pills .nav-item .nav-link {padding: 0px 20px;}
.ReMediaCharts >>> .tab-label > span{ display: inline-flex!important; }
.ReMediaCharts >>> .siteblock {display: flex; flex-wrap: wrap;}
.ReMediaCharts >>> .el-table table th:nth-last-child(2)  {text-align: right;}

/* .ReMediaCharts >>> .row-expand-hover:hover {cursor:pointer;} */
.ReMediaCharts >>> .row-expand-cover .el-table__expand-icon{visibility:hidden;}
.ReMediaCharts >>> .el-table__expand-icon {
    color: #00BF9A !important;
	font-size: 14px;
}

/*===chart===============================*/
.priceChart {display: flex; flex-direction: column;}
.ReMediaCharts >>> .card-chart {border: 1px solid #01b0e0; border-radius: 6px; padding: 10px;}
/* .ReMediaCharts >>> .card-chart h4 {margin-bottom: 10px;} */
.ReMediaCharts >>> .card-chart .chart-area {height: auto;}

@media (max-width: 825px){
	.ReMediaCharts-form .btn-position {margin-top: 10px;}	
	
}
@media (max-width: 768px){
	.ReMediaCharts >>> .siteblock {flex-direction: column;}
	.ReMediaCharts >>> .el-table .cell {padding: 0px;}
	.ReMediaCharts >>> .ReActionBtns {justify-content: flex-start;}
	.ReMediaCharts >>> .nav-pills.nav-pills:not(.flex-column) .nav-item:not(:last-child) .nav-link {
		margin-bottom: 15px;
	}
	.ReMediaCharts {padding: 15px; }
	.ReMediaCharts >>> .el-table table th:nth-last-child(2) {text-align: left;}
}
@media (max-width: 525px){
	.ReMediaCharts >>> .nav-pills .nav-item .nav-link {padding: 5px 20px;}
	.ReMediaCharts >>> .ReMarketingSitesOnObj {padding: 15px 5px 0px 15px; }
}

</style>
